import React, { createRef } from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import ArticleContent from '../../../components/articleContent';
import Atlas from '../atlas/index';
// import TopBanner from './topBanner';
import BottomBanner from './bottomBanner';
import HotRank from './hotRank';
import ReadNum from './readNum';
import ActivityBanner from './activityBanner';
import { h5PageCount } from 'ThreeTerminal_utils';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import { SimpleGuideLayer, WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { getArtilceCard } from '../../../../services/api';
import HiddenSeoTime, { VisibleSeoTime } from '../../../../common/seoUpdateTime';
import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';
// import GuideLayer from './guideLayer';
import Chip from 'Chip';
import OppoCutOff from './oppoCutOff';
// import ListenNews from './listenNews';

class Article extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        subid: PropTypes.string,
        unfoldType: PropTypes.string,
        unfoldTextInfo: PropTypes.object,
        stopReadArticle: PropTypes.array,
        wxLaunch: PropTypes.object,
        searchPath: PropTypes.string,
        isHitBlack: PropTypes.bool,
        activityOne: PropTypes.array,
        hasCopyRight: PropTypes.bool,
        sourceReason: PropTypes.string,
        openMoreReadAd: PropTypes.object,
        readNumConfig: PropTypes.object,
    };

    state = {
        stretch: false,
        oppoStretch: false,
        stretchHeight: 'auto',
        faceImgUrl: '',
        mediaName: '',
        isShowGuideLayer: false,
        topBannerData: '',
        bottomBannerData: '',
        getArtilceCardDone: false,
        // isShowSurveyPopup: false,
    };

    isStopRead = false;

    detailBox = createRef();

    componentDidMount() {
        const { content, stopReadArticle } = this.props;

        stopReadArticle.forEach((item) => {
            if (item.id === content.base62Id && !this.isStopRead) {
                this.isStopRead = true;
            }
        });
        this.isStretchFn();

        this.getArticleCardData();

        if (location.href.includes('oppowatchuid=')) {
            this.oppoStretchFn();
        }
    }

    getArticleCardData = async () => {
        const {
            content: { base62Id },
        } = this.props;

        try {
            const result = await getArtilceCard(base62Id);

            if (result && result.data) {
                this.setState({
                    topBannerData: result.data.topbanner || '',
                    bottomBannerData: result.data.bottombanner || '',
                });
            }
        } catch (e) {
            console.error(e);
        }

        this.setState({
            getArtilceCardDone: true,
        });
    };

    lookOriginalFn = (url, id, newstype) => {
        const { content } = this.props;
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        };

        // 查看原文点击统计
        h5PageCount([
            {
                behavior: 'action',
                type: 'ckyw',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: content.type || '',
                },
            },
        ]);
        this.handleClick(url, id, newstype, 'share01', downloads);
    };

    openAppLookFn = (url, id, newstype, isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const { content } = this.props;
        const downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1350561044933',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7495',
        };
        let countConfig = [];

        // 是否是小说推荐位区分
        if (location.href.includes('novelNew=1')) {
            countConfig = [
                {
                    behavior: 'action',
                    type: 'readtoapp',
                    other: {
                        ref: `ucms_${content.base62Id}`,
                        kind: 'other',
                    },
                },
            ];
        } else {
            countConfig = [
                {
                    behavior: 'action',
                    type: 'openNewsapp',
                    other: {
                        ref: `ucms_${content.base62Id}`,
                        kind: content.type || 'article',
                    },
                },
            ];
        }

        // 打开app查看更多点击统计
        if (isSendCount) {
            h5PageCount(countConfig);
        }
        if (isJumpQQlink && countConfig[0]) {
            countConfig[0].other.tag = 't9';
            h5PageCount(countConfig);
        }

        if (isCallAppWx) {
            this.handleClick(url, id, newstype, 'share52203', downloads, isJumpQQlink);
        }
    };

    flolowFn = (url, id, newstype) => {
        const { content } = this.props;
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        };

        // 关注按钮点击统计
        h5PageCount([
            {
                behavior: 'action',
                type: 'carefor',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: content.type || 'article',
                },
            },
        ]);
        this.handleClick(url, id, newstype, 'share01', downloads);
    };

    mediaClickFn = (url, id, newstype, isCallUp, isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const { content } = this.props;
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        };

        if (!isCallUp) {
            // 媒体账号点击统计

            if (isSendCount) {
                h5PageCount([
                    {
                        behavior: 'action',
                        type: 'carefor',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: content.type || 'article',
                        },
                    },
                ]);
            }

            if (isJumpQQlink) {
                h5PageCount([
                    {
                        behavior: 'action',
                        type: 'carefor',
                        other: {
                            ref: `ucms_${content.base62Id}`,
                            kind: content.type || 'article',
                            tag: 't9',
                        },
                    },
                ]);
            }

            if (isCallAppWx) {
                this.handleClick(url, id, newstype, 'share01', downloads, isJumpQQlink);
            }
        }
    };

    handleClick = (url, id, newstype, kind, downloads = {}, isJumpQQlink = false, noKindFrom) => {
        const {
            subid,
            content: { isVideoShare },
        } = this.props;
        const doc_type = newstype;
        const subidVal = subid ? `&subid=${subid}` : '';
        const aid = id + subidVal;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind: kind || 'share01',
            download: isVideoShare ? '' : downloads.download,
            downloadAd: isVideoShare ? '' : downloads.downloadAd,
            isCopySchemeUrl: isJumpQQlink,
            noKindFrom: noKindFrom ? noKindFrom : 0,
        });
    };

    searchPathNotShowMask() {
        const searchPathList = ['275893-'];
        const { searchPath } = this.props;

        if (!searchPath) {
            return false;
        }

        const filterResult = searchPathList.filter((item) => {
            return searchPath.indexOf(item) !== -1;
        });

        return !!filterResult.length;
    }

    isStretchFn() {
        const windowHeight = window.innerHeight * 1.5;
        const wordHeight = this.detailBox.current.offsetHeight;
        const stretchHig = windowHeight > 900 ? windowHeight : 900;

        if (wordHeight > windowHeight && !this.searchPathNotShowMask()) {
            this.setState({
                stretch: true,
                stretchHeight: `${stretchHig}px`,
            });
        }
    }
    oppoStretchFn = () => {
        const wordHeight = this.detailBox.current.offsetHeight;

        this.setState({
            stretch: true,
            oppoStretch: true,
            stretchHeight: `${wordHeight / 10}px`,
        });
    };
    showAllTexFn = () => {
        const { content, unfoldType } = this.props;

        // 关注按钮点击统计
        if (unfoldType !== '2' && unfoldType !== '3') {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'showbar',
                    other: {
                        ref: `ucms_${content.base62Id}`,
                        kind: content.type || 'article',
                    },
                },
            ]);
        }

        if ((unfoldType === '2' || unfoldType === '3' || this.isStopRead) && !content.isVideoShare) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: unfoldType === '2' ? 'showbarArticleExp1' : 'showbarArticleExp2',
                    other: {
                        ref: `ucms_${content.base62Id}`,
                        kind: content.type || 'article',
                    },
                },
            ]);
            this.setState({
                isShowGuideLayer: true,
            });
        } else {
            this.setState({
                stretch: false,
                stretchHeight: 'auto',
            });
        }
    };

    closeGuideFn = () => {
        const { content, unfoldType } = this.props;

        // 关注按钮点击统计
        h5PageCount([
            {
                behavior: 'action',
                type: 'cancelentry',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: content.type || 'article',
                },
            },
        ]);

        if (unfoldType === '3' || this.isStopRead) {
            this.setState({
                isShowGuideLayer: false,
            });
        } else {
            this.setState({
                stretch: false,
                stretchHeight: 'auto',
                isShowGuideLayer: false,
            });
        }
    };

    gotoClientFn = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { content, unfoldType } = this.props;
        let artType = content.type === 'article' ? 'doc' : content.type;
        const url = typeof window === 'object' ? location.href : '';
        const id = content._id;
        let guideKind = 'share01';
        let showbarAction = 'showbar';

        if (unfoldType === '2') {
            guideKind = 'inter_ymdl01';
            showbarAction = 'showbarArticle1';
        }

        if (unfoldType === '3') {
            guideKind = 'inter_ymdl02';
            showbarAction = 'showbarArticle2';
        }

        artType = artType === 'slide' ? 'immersionslide' : artType;

        h5PageCount([
            {
                behavior: 'action',
                type: showbarAction,
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: content.type || 'article',
                },
            },
        ]);

        let downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1350561044933',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7495',
        };

        if (unfoldType === '2') {
            downloads = {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7226559215531995136',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9138',
            };
        }

        if (unfoldType === '3') {
            downloads = {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7226560400942968832',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9139',
            };
        }

        if (isCallApp) {
            this.handleClick(url, id, artType, guideKind, downloads, isJumpQQlink, 1);
        }
    };

    getSchemeLinkGuide = () => {
        const { unfoldType, content, wxLaunch } = this.props;
        let guideKind = 'share01';

        if (unfoldType === '2') {
            guideKind = 'inter_ymdl01';
        }

        if (unfoldType === '3') {
            guideKind = 'inter_ymdl02';
        }
        const schemeLinkGuide =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: content.type === 'article' ? 'doc' : content.type,
                      pid: content._id,
                  })
                : getSchemeLink({
                      docType: content.type === 'article' ? 'doc' : content.type,
                      pid: content._id,
                      kind: guideKind,
                      noKindFrom: 1,
                  });

        return schemeLinkGuide;
    };
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        let {
            content,
            subid,
            unfoldType,
            unfoldTextInfo,
            wxLaunch,
            isHitBlack,
            activityOne,
            hasCopyRight,
            sourceReason,
            openMoreReadAd,
            readNumConfig,
            searchPath,
        } = this.props;
        const {
            stretch,
            oppoStretch,
            stretchHeight,
            isShowGuideLayer,
            topBannerData,
            bottomBannerData,
            getArtilceCardDone,
            // isShowSurveyPopup,
        } = this.state;
        const style = {
            height: stretchHeight,
            paddingTop: content.type === 'short' ? '0' : 'auto',
        };
        const pluginData = {
            videosPluginData: content.videosPluginData,
            slidesPluginData: content.slidesPluginData,
            surveyPluginData: content.surveyPluginData,
            audiosPluginData: content.audiosPluginData,
            houseBuildPluginData: content.housePropertyPlugin,
            houseSourcePluginData: content.houseResourcesPlugin,
            houseRegionPluginData: content.houseResourcesPlugin,
            houseSurveyPluginData: content.houseSurveyPlugin,
            goodsPlugin: content.goodsPlugin,
        };

        const pageInfo = {
            isVideoShare: content.isVideoShare,
            base62Id: content.base62Id,
            _id: content._id,
            isShowCallup: false,
            type: content.type,
            callAppSurveyConfig: {
                docType: 'doc',
                pid: content._id,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7174415196693892096',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9195',
                kind: 'inter_mdfcld0201',
                noKindFrom: 1,
            },
            isShowArticleSurvey: true,
            isShowSurveyPopup: false,
            clickSurveyCount: {
                clickBar: {
                    behavior: 'action',
                    type: 'survey_pop',
                    other: {
                        id: `ucms_${content.base62Id}`,
                        surveyid: `survey_${
                            pluginData?.surveyPluginData?.attachmentId || pluginData?.surveyPluginData?.id
                        }`,
                        url: typeof window === 'object' ? encodeURIComponent(location.href) : '',
                    },
                },
                clickCallApp: {
                    behavior: 'action',
                    type: 'survey_pop_app',
                    other: {
                        id: `ucms_${content.base62Id}`,
                        surveyid: `survey_${
                            pluginData?.surveyPluginData?.attachmentId || pluginData?.surveyPluginData?.id
                        }`,
                        url: typeof window === 'object' ? encodeURIComponent(location.href) : '',
                    },
                },
                clickSubmit: {
                    behavior: 'action',
                    type: 'subquest',
                    other: {
                        id: `ucms_${content.base62Id}`,
                        surveyid: `survey_${
                            pluginData?.surveyPluginData?.attachmentId || pluginData?.surveyPluginData?.id
                        }`,
                    },
                },
            },
            clickCount: {
                behavior: 'v',
                type: 'video',
                other: {
                    vid: `ucms_${content.base62Id}`,
                    vtype: 'vv',
                    url: typeof window === 'object' ? encodeURIComponent(location.href) : '',
                },
            },
            firstPlayCount: {
                behavior: 'v',
                type: 'video',
                other: {
                    vid: `ucms_${content.base62Id}`,
                    vtype: 'cv',
                    url: typeof window === 'object' ? encodeURIComponent(location.href) : '',
                },
            },
            actionCount: {
                behavior: 'action',
                type: 'videohike',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: 'article',
                },
            },
            clickVideoBoxCount: {
                behavior: 'action',
                type: 'bounced',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: 'article',
                },
            },
            clickLaterCount: {
                behavior: 'action',
                type: 'noc',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: 'article',
                },
            },
            clickGotoCount: {
                behavior: 'action',
                type: 'yesc',
                other: {
                    ref: `ucms_${content.base62Id}`,
                    kind: 'article',
                },
            },
            clickFirstAudio: {
                behavior: 'v',
                type: 'audio',
                other: {
                    vid: `ucms_${content.base62Id}`,
                    vtype: 'cv',
                    url: typeof window === 'object' ? encodeURIComponent(location.href) : '',
                },
            },
            clickAudioPlay: {
                behavior: 'v',
                type: 'audio',
                other: {
                    vid: `ucms_${content.base62Id}`,
                    vtype: 'vv',
                    url: typeof window === 'object' ? encodeURIComponent(location.href) : '',
                },
            },
        };
        const subscribe = content.subscribe || {};
        let artType = content.type === 'article' ? 'doc' : content.type;
        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: content.type === 'article' ? 'doc' : content.type,
                      pid: content._id,
                  })
                : getSchemeLink({
                      docType: content.type === 'article' ? 'doc' : content.type,
                      pid: content._id,
                      kind: 'share01',
                  });
        const schemeLinkGuide = this.getSchemeLinkGuide();
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const wxLaunchType = wxLaunch.wxLaunchType;
        const isQuanRelate = content.quanPlugin && content.quanPlugin !== '{}';
        // const isShowEditName = hasCopyRight || sourceReason === '公开信息';

        artType = artType === 'slide' ? 'immersionslide' : artType;
        unfoldType = this.isStopRead ? '3' : unfoldType;
        readNumConfig = {
            ...readNumConfig,
            base62Id: content.base62Id,
            hasCopyRight,
            createTime: content.createTime,
            searchPath,
        };

        return (
            <section className={`${styles.container} ${content.type === 'short' ? styles.shortStyle : ''}`}>
                <article className={styles.containerBox} ref={this.detailBox} style={style}>
                    <header>
                        {content.type !== 'short' && (
                            <div id="articleTitle">
                                <h1 className={styles.title}>{content.title}</h1>
                            </div>
                        )}
                        <div className={styles.info}>
                            <div className={styles.infobox}>
                                {/* 自媒体和非自媒体逻辑结构判断 */}
                                <a
                                    href={
                                        !subscribe.forbidJump && subscribe.authorUrl ? subscribe.authorUrl : 'javascript:;'
                                    }
                                    className={styles.infoboxLink}
                                    onClick={this.mediaClickFn.bind(
                                        this,
                                        typeof window === 'object' ? location.href : '',
                                        content._id,
                                        artType,
                                        subscribe.authorUrl,
                                    )}>
                                    {subscribe.logo && (
                                        <div className={styles.face}>
                                            <img className={styles.faceImg} src={subscribe.logo} />
                                            {subscribe.honorImg && (
                                                <img src={subscribe.honorImg} className={styles.faceV} />
                                            )}
                                            {!content.isVideoShare && !subscribe.authorUrl && wxLaunchSwitch && (
                                                <WxLaunchApp
                                                    launchType={wxLaunchType}
                                                    launchAppClick={this.mediaClickFn.bind(
                                                        this,
                                                        typeof window === 'object' ? location.href : '',
                                                        content._id,
                                                        artType,
                                                        subscribe.authorUrl,
                                                        true,
                                                        false,
                                                        false,
                                                    )}
                                                    schemeLink={schemeLink}
                                                    launchAppFail={this.mediaClickFn.bind(
                                                        this,
                                                        typeof window === 'object' ? location.href : '',
                                                        content._id,
                                                        artType,
                                                        subscribe.authorUrl,
                                                        false,
                                                        true,
                                                        true,
                                                    )}
                                                />
                                            )}
                                        </div>
                                    )}
                                    <div className={styles.text}>
                                        <span className={styles.source} rel="medianame">
                                            {subscribe.catename}
                                            {/* {subscribe.cateSource && <span className={styles.wemedia} />} */}
                                        </span>
                                        <div className={styles.timeBref}>
                                            {subscribe.originalName && (
                                                <span className={styles.original}>{subscribe.originalName}</span>
                                            )}
                                            <VisibleSeoTime publishTime={content.createTime} className={styles.time}>
                                                {content.newsTime}
                                            </VisibleSeoTime>
                                            <HiddenSeoTime publishTime={content.createTime} updateTime={content.updateTime} />
                                            {subscribe.description && (
                                                <span className={styles.bref}>{subscribe.description}</span>
                                            )}
                                            <span className={styles.fromeAddress}>
                                                &nbsp;&nbsp;{subscribe?.lastArticleAddress || ''}
                                            </span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <ReadNum content={readNumConfig} />
                        </div>
                        {subscribe.declare && <div className={styles.disclaimer}>{subscribe.declare}</div>}
                        {/* {content.type !== 'short' && content.type !== 'slide' && topBannerData && (
                            <TopBanner content={topBannerData} base62Id={content.base62Id} />
                        )} */}
                    </header>
                    <section className={styles.detail}  aria-label="正文">
                        <div className={styles.detailBox} id="articleBox">
                            {content.summary &&
                                !isQuanRelate &&
                                content.summary !== content.title &&
                                content.type !== 'short' && (
                                    <div className={styles.summary} aria-label="摘要">
                                        <div className={styles.summaryTop}>
                                            <span className={styles.summarySquare} />
                                            <span className={styles.summaryLine} />
                                        </div>
                                        <div className={styles.summaryText}>{content.summary}</div>
                                        <div className={styles.summaryBottom}>
                                            <span className={styles.summaryLine} />
                                            <span className={styles.summarySquare} />
                                        </div>
                                    </div>
                                )}
                            {/* {!isHitBlack && <ListenNews content={content.listenNewsConfig} />} */}
                            {content.contentData && content.contentData.contentList && (
                                <ArticleContent
                                    content={content.contentData}
                                    pageType={content.type}
                                    imagesInContent={content.imagesInContent}
                                    thumbnails={content.thumbnails}
                                    pluginData={pluginData}
                                    pageInfo={pageInfo}
                                    base62Id={content.base62Id}
                                    _id={content._id}
                                    isBig={false}
                                    wxLaunch={wxLaunch}
                                />
                            )}
                            {content.slideData && content.slideData.length !== 0 && (
                                <Atlas
                                    content={content.slideData}
                                    isVideoShare={content.isVideoShare}
                                    proid={content.base62Id}
                                    _id={content._id}
                                    subid={subid}
                                    wxLaunch={wxLaunch}
                                />
                            )}
                            {/* {content.editorCode &&
                                isShowEditName && (
                                    <div className={styles.editor}>
                                        责任编辑：{content.editorName} {content.editorCode}
                                    </div>
                                )} */}
                        </div>
                    </section>
                    {stretch && !oppoStretch && (
                        <Chip
                            id="170111"
                            type="struct"
                            title="点击查看更多展现形式"
                            groupName="点击查看更多展现形式"
                            translate="handleUnfoldTypeData">
                            <div onClick={this.showAllTexFn} className={styles.shadow}>
                                {/* <span className={styles.shadowBar} /> */}
                                <span className={styles.unfoldIcon} />
                            </div>
                        </Chip>
                    )}
                    {oppoStretch && (
                        <OppoCutOff
                            pageType={content.type}
                            base62Id={content.base62Id}
                            createTime={content.createTime}
                        />
                    )}
                </article>
                {content.type !== 'short' && !oppoStretch && (
                    <>
                        <div
                            onClick={this.openAppLookFn.bind(
                                this,
                                typeof window === 'object' ? location.href : '',
                                content._id,
                                artType,
                            )}
                            className={styles.callupBtn}>
                            打开APP阅读更多精彩内容
                            {!content.isVideoShare && wxLaunchSwitch && (
                                <WxLaunchApp
                                    launchType={wxLaunchType}
                                    launchAppClick={this.openAppLookFn.bind(
                                        this,
                                        typeof window === 'object' ? location.href : '',
                                        content._id,
                                        artType,
                                        true,
                                        false,
                                        false,
                                    )}
                                    schemeLink={schemeLink}
                                    launchAppFail={this.openAppLookFn.bind(
                                        this,
                                        typeof window === 'object' ? location.href : '',
                                        content._id,
                                        artType,
                                        false,
                                        true,
                                        true,
                                    )}
                                />
                            )}
                        </div>
                        <NoSSR>
                            <Ad content={openMoreReadAd} />
                        </NoSSR>
                    </>
                )}
                {!isHitBlack && activityOne && activityOne.length > 0 && (
                    <ActivityBanner
                        isVideoShare={content.isVideoShare}
                        base62Id={content.base62Id}
                        wxLaunch={wxLaunch}
                        activityOne={activityOne}
                        type={content.type}
                    />
                )}
                {bottomBannerData && (
                    <BottomBanner
                        content={bottomBannerData}
                        base62Id={content.base62Id}
                        _id={content._id}
                        wxLaunch={wxLaunch}
                        isVideoShare={content.isVideoShare}
                    />
                )}
                {!isHitBlack && getArtilceCardDone && !bottomBannerData && <HotRank base62Id={content.base62Id} />}

                <SimpleGuideLayer
                    isShowGuideLayer={isShowGuideLayer}
                    unfoldType={unfoldType}
                    unfoldTextInfo={unfoldTextInfo}
                    closeGuideFn={this.closeGuideFn}
                    gotoClientFn={this.gotoClientFn}
                    wxLaunchType={wxLaunch.wxLaunchType}
                    wxLaunchSwitch={wxLaunch.wxLaunchSwitch}
                    schemeLink={schemeLinkGuide}
                />
            </section>
        );
    }
}

export default errorBoundary(Article);
